<div class="date-period" *ngIf="config">

  <div class="input-group xux-input-group">

    <fieldset>
      <span class="input-group-addon" *ngIf="config.showInputLabel">
        <span class="input-group-title">{{label}}</span>
      </span>

      <div class="input-group-control" [class.disabled]="config.disabled">
        <label class="date-period-label">
          <xux-icon icon='icon-calendar' data-testid="datepicker-icon" (click)="showModal(modalTemplate, $event)"></xux-icon>
          <input
            data-testid="date-start-calendar-input"
            type="text"
            class="date-period-input"
            data-e2e-id="date-start-calendar-input"
            [class.width-50]="show2ndField"
            [value]="formatDate(value?.dateStart, config.dateFormat.short_date_format)"
            (change)="onInput($event, 'dateStart')"
            [readonly]="!isEditable()"
            [placeholder]="config.placeholder"
            [disabled]="config.disabled"
          />
          <ng-container *ngIf="show2ndField">
            <span class="chevron"></span>
            <input
              data-testid="date-end-calendar-input"
              type="text"
              class="date-period-input"
              data-e2e-id="date-end-calendar-input"
              [class.width-50]="show2ndField"
              [value]="formatDate(value?.dateEnd, config.dateFormat.short_date_format,1)"
              (change)="onInput($event, 'dateEnd')"
              [readonly]="!isEditable()"
              [disabled]="config.disabled"
            />
          </ng-container>
        </label>
      </div>
    </fieldset>

  </div>
</div>

<ng-template #modalTemplate>
  <xux-datepicker
    data-testid="xux-datepicker"
    [i18n]="staticTextContent.xuxDatepicker"
    [config]="config"
    [periods]="periods"
    [weekPeriods]="weekPeriods"
    [value]="defaultValue"
    (onCancel)="hideModal()"
    (onApply)="applyValue($event)"
  ></xux-datepicker>
</ng-template>
